import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=91f84e08&scoped=true&"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=91f84e08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f84e08",
  null
  
)

export default component.exports